import Request from './request'

const Device = {
  getDevices (page, params, callback) {
    Request.post('devices/' + page, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDevicesCSV (params, callback) {
    Request.post('devices/as-csv', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getModelsDevices (callback){
    Request.get('devices/models-list').then(callback).catch(this.bad_answer)
  },
  getFirmWareVersions(callback){
    Request.get('devices/firmware-versions').then(callback).catch(this.bad_answer)
  },
  getDeviceProfile (fid, callback) {
    Request.get('device/view/' + fid).then(callback).catch(this.bad_answer)
  },
  getDeviceHistoryAction(params, callback) {
    Request.post('device/actions-log', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceSimcards (fid, callback) {
    Request.post('device/simcard-list/' + fid).then(callback).catch(this.bad_answer)
  },
  saveDeviceProfile (params, callback) {
    if (!params) {
      params = {}
    }
    Request.post('device/save/' + params.fid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  saveDeviceLogs (fid, tsStart, tsEnd, callback) {
    Request.post('device/savelog/' + fid, JSON.stringify({ ts_start: tsStart, ts_end: tsEnd})).then(callback).catch(this.bad_answer)
  },
  getDeviceLog(fid, params, callback) {
    Request.post('device/internal-log/' + fid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceConfig (fid, callback) {
    Request.get('device/get-config/' + fid).then(callback).catch(this.bad_answer)
  },
  saveDeviceConfig (fid, params, callback) {
    Request.post('device/save-config/' + fid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  resetDeviceConfigVersion (fid, callback) {
    Request.post('device/reset-ver-config/' + fid).then(callback).catch(this.bad_answer)
  },
  setDeviceBlockStatus (fid, params, callback) {
    Request.post('device/set-block-status/' + fid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getConfigByVersion (fid, params, callback){
    Request.post('device/get-config-by-version/' + fid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getConfigDocumentation (callback){
    Request.get('device/get-config-documentation').then(callback).catch(this.bad_answer)
  }
}
export default Device
